import React, { useEffect, useRef } from 'react'


function PerfilUsuario() {
    const servidorSocket = useRef();
    const iniciarConeccion = () => {
        const socket = new WebSocket('ws://172.19.83.98:65432');
        socket.onopen = () => {
            console.log('Conectado al servidor');
            socket.send('Hola desde el cliente');
        };
        socket.onmessage = (event) => {
            console.log('Mensaje del servidor:', event.data);
        };
        socket.onclose = () => {
            console.log('Conexión cerrada');
        };
        socket.onerror = (error) => {
            console.error('Error de conexión:', error);
        };
        servidorSocket.current=socket;
    }
    const sendMessage =()=>{
        servidorSocket.current.send("hola mundo")
    }
    useEffect(() => {
        //iniciarConeccion()
    }, [])
    return (
        <div>
            <button className='btn btn-sm btn-success'
                onClick={() => iniciarConeccion()}
            >Conectar</button>
            <button className='btn btn-sm btn-secondary'
                onClick={()=>sendMessage()}>
                Send Mensaje
            </button>
        </div>
    )
}

export default PerfilUsuario